const STORAGE_KEY = "publicCalendarContext";

export const savePublicCalendarContext = (payload) => {
  try {
    if (!payload || !payload.masjidId) return;
    const data = {
      masjidId: payload.masjidId,
      masjid: payload.masjid || null,
      savedAt: Date.now(),
    };
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(data));
  } catch (err) {
    console.error("Failed to store public calendar context", err);
  }
};

export const loadPublicCalendarContext = () => {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch (err) {
    console.error("Failed to load public calendar context", err);
    return null;
  }
};

export const clearPublicCalendarContext = () => {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch (err) {
    console.error("Failed to clear public calendar context", err);
  }
};
